
export class Page<T> {
  items: T[];
  index = 0;

  constructor(items?: T[]) {
    this.items = items || [];
  }
}

export class Paginator<T> {
  pages!: Page<T>[];
  items!: T[];
  pageSize: number;

  get count() {
    return this.pages.length;
  }

  constructor(items: T[], pageSize: number) {
    this.pageSize = pageSize;
    this.items = items;
    this.pages = items.reduce((acc: Page<T>[], val: T, i: number) => {
      const index = Math.floor(i / pageSize);
      const existing = acc.find(p => p.index === index);
      const page = new Page<T>();
      (existing || page).items = [...(existing || page).items, val];
      (existing || page).index = index;
      if (!existing) {
        acc.push(page);
      }
      return acc as Page<T>[];
    }, []);
  }
}